<template>

<!--   <EditMini miniProfile="lc:profile:bf2:Hub"></EditMini> -->
  <EditMini miniProfile="Hub"></EditMini>

</template>


<style type="text/css">

   

</style>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

import EditMini from "@/views/EditMini.vue";





export default {
  name: "EditMiniTest",
  components: {
    EditMini
    
  }

  
};
</script>
